
import React, { useState, useEffect } from 'react';
import { FaInstagram, FaPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import InfluencerHeader from './InfluencerHeader';
import Navbar from './Navbar';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateLink = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [userdata, setUserdata] = useState(null);

  useEffect(() => {
    getInfluencerData();
  }, []);

  const getInfluencerData = () => {
    const influencerId = localStorage.getItem("influencerID");
    if (!influencerId) {
      console.log("No influencer ID found in localStorage.");
      return;
    }
    fetch(`https://server-side-influencer.onrender.com/influencer/getInfluencer/${influencerId}`)
      .then((response) => response.json())
      .then((data) => {
        setUserdata(data.data);
      })
      .catch((err) => {
        console.error("Error fetching influencer data:", err);
      });
  };

  const handleNavigateIfApproved = (targetRoute) => {
    if (userdata?.amazonTrackingId && userdata.amazonTrackingId.trim() !== "") {
      navigate(targetRoute);
    } else {
      setShowModal(true);
    }
  };

  const handleSendRequest = async () => {
   try {
      const influencerId = localStorage.getItem("influencerID");
      const res = await fetch("https://server-side-influencer.onrender.com/influencer/affiliate-request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: influencerId }),
      });

      const data = await res.json();

      if (res.ok) {
        toast.success("Affiliate request sent successfully!");
      } else {
        toast.error(data.message || "Request failed");
      }
    } catch (error) {
      console.error("Affiliate request error:", error);
      toast.error("Failed to send affiliate request.");
    }
    setShowModal(false);
  };

  return (
    <div className="flex flex-col h-screen">
      {/* Top Header */}
      <div className="fixed top-0 left-0 right-0 z-10 bg-white shadow-md">
        <InfluencerHeader page="Create Link" />
      </div>

      {/* Sidebar */}
      <div className="fixed top-0 left-0 bottom-0 w-0 z-20">
        <Navbar />
      </div>

      {/* Main Content */}
      <div className="flex-1 ml-10 p-6 pt-20">
        <h1 className="text-2xl font-semibold text-black-800 mb-10 text-center mt-10">
          Create product link and share
        </h1>

        {/* Two Boxes */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 ml-6 mt-40">
          <div
            onClick={() => handleNavigateIfApproved("/selectproduct")}
            className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center justify-center h-64 cursor-pointer hover:shadow-lg transition"
          >
            <div className="text-pink-500 text-5xl mb-4">
              <FaInstagram />
            </div>
            <p className="text-center text-gray-700 font-medium text-lg">
              Add product to existing Instagram reel or post
            </p>
          </div>

          <div
            onClick={() => handleNavigateIfApproved("/generatelink")}
            className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center justify-center h-64 cursor-pointer hover:shadow-lg transition"
          >
            <div className="text-blue-500 text-5xl mb-4">
              <FaPlus />
            </div>
            <p className="text-center text-gray-700 font-medium text-lg">
              Quickly share your favourite products
            </p>
          </div>
        </div>
      </div>

      {/* ✅ Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white rounded-xl shadow-lg max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-3 text-gray-500 hover:text-red-600 text-xl font-bold"
            >
              ×
            </button>

            <h3 className="text-xl font-bold mb-4 text-center">Affiliate Partnership Terms</h3>
            <p className="text-gray-700 text-sm mb-6">
              To become an affiliate partner of <strong>Smesh</strong>, you need to request approval.
              Once requested, your account will be reviewed within 24 hours.
              If approved, you’ll be able to generate affiliate links and earn commissions.
            </p>

            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
    <button 
  onClick={handleSendRequest}
  className="px-4 py-2 text-sm tracking-wide rounded-lg text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl transition-all duration-300 disabled:opacity-60 shadow-md"
>
  Send Request
</button>

            </div>
          </div>
        </div>
      )}

      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
};

export default CreateLink;